export default {
    packages_delete_package_title: "Delete Package",
    packages_delete_package_description: "Are you sure you want to delete the package?",
    packages_delete_package_success_message: "The package has been deleted",
    packages_delete_package_error_message: "It was not possible to delete the package due to an error",
    packages_delete_package_in_use: "The package is linked to some users, change the package of the users and try again",
}